import { Outlet, useLocation } from "react-router-dom";
import styled from "styled-components";
import StudentHeader from "shared/components/StudentHeader";
import useStudentProfile from "features/teacher/hooks/student/useStudentProfile";
import { scrollbar } from "features/homework/homeworkUi";

const StudentProfile = () => {
    const student_uid = useLocation().state;
    const { student, lesson, teacher } = useStudentProfile(student_uid);

    return (
        <Page>
            <StudentHeader name={student.name} content={`${lesson.name} - ${teacher.name}`} />
            <Body>
                <Outlet />
            </Body>
        </Page>
    );
};

const Page = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    flex: 1;
    min-height: 0;
    overflow: hidden;
    padding: 20px 24px;
`;

const Body = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 0;
    overflow: auto;
    ${scrollbar}
`;

export default StudentProfile;
